export const Profile_DA = {
  profile: {
    tabs: {
      feed: "Væg",
      challenges: "Challenges",
      community: "Fællesskab",
      gathers: "Gathers",
      teams: "Hold",
      achievements: "Achievements",
      error: "Der opstod en fejl. Vi kunne ikke indlæse dine data.",
      mobile: {
        noChallenges: "Du har ikke lavet nogen challenges endnu.",
        createChallenge: "Opret en udfordring",
        nothingFound: "Ingen resultater relateret til",
      },
    },
    challenges: {
      badges: {
        all: "Alle",
        participatingIn: "Deltager i",
        createdBy: "Oprettet af",
        favorites: "Favoritter",
        private: "Privat",
        completed: "Afsluttet",
        drafts: "Kladder",
      },
    },
    community: {
      heading: "fællesskab",
      tabs: {
        friends_singular: "ven",
        friends_plural: "venner",
        following_singular: "følges af",
        following_plural: "følgere",
        followers_singular: "følger",
        followers_plural: "følger",
        empty_string1: "har ikke nogle", // {userName} does not have any {currentTab} yet.
        empty_string2: "endnu", // {userName} does not have any {currentTab} yet.
        following_empty_string1: "har ikke nogle", // {userName} does not have a {currentTab} yet,
        following_empty_string2: "endnu", // {userName} does not have a {currentTab} yet.
      },
      search: {
        placeholder: "Søg efter brugernavn",
      },
    },
    friends: {
      title: "Venner",
      no_friends_msg: "Denne bruger har ingen venner endnu.",
    },
    edit: {
      title: "Rediger profil",
      tabs: {
        Avatar: "Avatar",
        Information: "Information",
        Connections: "Forbindelser",
        Themes: "Temaer",
      },
      avatar: {
        edit_msg: "Skift avatar",
        upload_msg:
          "Upload et billede eller vælg et af vores predefinerede avatarer.",
        upload_title: "Upload avatar",
      },
      connections: {
        title: "Tilføj konti til din profil",
        // In between desc1 and desc2 is the brands name
        desc1: "Forbind din", // NEW
        desc2:
          "profil med tredje-parter for at deltage i aktiviteter såsom Challenges. Du kan altid fjerne forbindelsen igen. Adgangskoder og betalingsinfo vil aldrig blive delt.", // NEW
        no_connections: "Ingen forbindelser", // NEW
        // In between desc1 and desc2 is the brands name
        no_connections_desc1: "Lås op", // NEW
        no_connections_desc2: "for alle funktioner ved at forbinde dine konti", // NEW
      },
      themes: {
        choose_msg:
          "Vælg et tema og slutt dig til en af ​​vores partnere i deres zone for at få premium funktioner og aktiviteter gratis",
      },
    },
    toast: {
      edit: {
        success: "Profil opdateret.",
        failed: "Noget gik galt, og din profil er ikke opdateret.",
      },
    },
    actions: {
      add_friend: "Tilføj ven",
      unfriend: "Fjern ven",
      cancel_friend_request: "Annuller venneanmodning",
      accept_friend_request: "Accepter venneanmodning",
      decline_friend_request: "Afvis venneanmodning",
      follow: "Følg",
      unfollow: "Stop med at følge",
    },
  },
};
